var _path, _path2, _circle, _circle2, _path3, _path4, _path5, _path6, _path7, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatureIntegration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 128,
    viewBox: "0 0 160 128",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A balance scale") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 24v79",
    stroke: "#45556D",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m26 43 108-14",
    stroke: "#45556D",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 36,
    r: 8,
    fill: "#A27A5F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 36,
    r: 3,
    fill: "#FFF1E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 42 15 79m19-37 19 37m73-49-19 37m19-37 19 37",
    stroke: "#A27A5F",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 79h46a23 18 0 0 1-46 0Z",
    fill: "#D7E0EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M103 67h46a23 18 0 0 1-46 0Z",
    fill: "#D7E0EB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11 79h46m46-12h46",
    stroke: "#A6B2C2",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80 94 62 109h36L80 94Z",
    fill: "#45556D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 106,
    width: 58,
    height: 9,
    rx: 4.5,
    fill: "#45556D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIntegration);
export default __webpack_public_path__ + "static/media/feature-integration.63c97ef75137aae122ae76e7eaafbe32.svg";
export { ForwardRef as ReactComponent };